export const getKinshasaDateTime = () => {
  const date = new Date();

  const formatter = new Intl.DateTimeFormat("fr-CD", {
    timeZone: "Africa/Kinshasa",
    dateStyle: "short",
    timeStyle: "medium",
  });
  return formatter.format(date); //"28/06/2025, 15:32:44"
};

export const getKinshasaDate = () => {
  const date = new Date();

  // Convertir la date en heure de Kinshasa
  const kinshasaDate = new Date(
    date.toLocaleString("en-US", {
      timeZone: "Africa/Kinshasa",
    })
  );

  // Extraire et formater
  const day = String(kinshasaDate.getDate()).padStart(2, "0");
  const month = String(kinshasaDate.getMonth() + 1).padStart(2, "0");
  const year = kinshasaDate.getFullYear();

  return `${day}-${month}-${year}`; // ex: "11-07-2025"
};

export const getKinshasaTime = () => {
  const date = new Date();

  const formatter = new Intl.DateTimeFormat("fr-CD", {
    timeZone: "Africa/Kinshasa",
    timeStyle: "medium", // Format : "15:42:30"
  });

  return formatter.format(date);
};

export const getKinshasaDateNowmdyhms = () => {
  const now = new Date();

  const formatter = new Intl.DateTimeFormat("fr-CD", {
    timeZone: "Africa/Kinshasa",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // 24h
  });

  const parts = formatter.formatToParts(now);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "";

  const dd = get("day");
  const mm = get("month");
  const yyyy = get("year");
  const hh = get("hour");
  const min = get("minute");
  const ss = get("second");

  // dd_mm_yyyy_hh_mm_ss
  return `${dd}_${mm}_${yyyy}_${hh}_${min}_${ss}`;
};
export const getKinshasaTimeHMS = () => {
  const now = new Date();

  const formatter = new Intl.DateTimeFormat("fr-CD", {
    timeZone: "Africa/Kinshasa",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(now);
  const get = (type) => parts.find((p) => p.type === type)?.value ?? "";

  const hh = get("hour");
  const min = get("minute");
  const ss = get("second");

  // hh_mm_ss
  return `${hh}_${min}_${ss}`;
};
